export default "__VITE_ASSET__8l5CQjFs__"